import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";
import { obtenerAuditoriaListaPrecios } from "./contextoSesion";

const post = (ruta, request) => _Componentes_WebApiCalls_Post(`ListasPrecios/${ruta}`, request);

export const credencialesListaPrecios = () => obtenerAuditoriaListaPrecios();

export const listarListasPrecios = (EmpresaId, bVigentes = false) =>
  post("Listas", { EmpresaId, Seleccionado: 0, bVigentes });

export const obtenerMercaderiasLista = (EmpresaId, Id) =>
  post("MercaderiasAsignadas", { EmpresaId, Id: Number(Id) || 0 });

export const obtenerMercaderiasDisponibles = (EmpresaId) =>
  post("MercaderiasDisponibles", { EmpresaId });

export const obtenerClientesLista = (EmpresaId, Id) =>
  post("ClientesAsignados", { EmpresaId, Id: Number(Id) || 0 });

export const obtenerClientesDisponibles = (EmpresaId) =>
  post("ClientesDisponibles", { EmpresaId });

export const obtenerMonedaTipos = (EmpresaId) =>
  _Componentes_WebApiCalls_Post("Combos/MonedaTipos", {
    UnTodos: false,
    UnNinguno: false,
    EmpresaId,
  });

export const guardarListaPrecio = ({ EmpresaId, resumen, mercaderias, clientes }) =>
  post("Update", {
    EmpresaId,
    ...credencialesListaPrecios(),
    oResumen: resumen,
    lstMercaderias: mercaderias,
    lstClientes: clientes,
  });

export const copiarListaPrecio = ({ EmpresaId, ListaId, descripcion, fechaDesde, fechaHasta }) =>
  post("CopiarLista", {
    EmpresaId,
    ...credencialesListaPrecios(),
    ListaId: Number(ListaId) || 0,
    sDescripcion: descripcion,
    FechaDesde: fechaDesde,
    FechaHasta: fechaHasta,
    AsignarClientes: false,
  });

export const actualizarPreciosRapidos = ({ EmpresaId, ListaId, precios }) =>
  post("SetPrecio", {
    EmpresaId,
    ...credencialesListaPrecios(),
    ListaId: Number(ListaId) || 0,
    Precios: precios,
  });
